import _ from 'lodash';
import { API_V1 } from './APIs/APIv1';
import Logger from '../logger';
import { ImitationScore, DetailsCategoryScore } from '../types/user-tracker.types';

export const createUserTracker = async (
  profile?: string,
  username?: string,
  timeOfStart?: Date,
  timeOfEnd?: Date,
  imitationScore?: ImitationScore,
  detailsCategoryScoreStart?: DetailsCategoryScore,
  detailsCategoryScoreEnd?: DetailsCategoryScore,
  improvementScore?: number,
  calculationTime?: number
) => {
  try {
    const res = await API_V1.post('/user-tracking/trackers', {
      profile,
      username,
      timeOfStart,
      timeOfEnd,
      imitationScore,
      detailsCategoryScoreStart,
      detailsCategoryScoreEnd,
      improvementScore,
      calculationTime,
    });
    return res.data;
  } catch (e) {
    Logger.trace('Error while creating user tracker');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const getUserTrackers = async (duration1: Date, duration2: Date, category: string, company?: string) => {
  try {
    const res = await API_V1.get('/user-tracking/trackers', {
      params: {
        duration1,
        duration2,
        category,
        company: company === '' ? undefined : company,
      },
    });
    return res.data;
  } catch (e) {
    Logger.trace('Error while creating user tracker');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

// External endpoint - uses apiKey instead of token
export const createUserTrackerExternal = async (
  apiKey: string,
  profile?: string,
  username?: string,
  timeOfStart?: Date,
  timeOfEnd?: Date,
  imitationScore?: ImitationScore,
  detailsCategoryScoreStart?: DetailsCategoryScore,
  detailsCategoryScoreEnd?: DetailsCategoryScore,
  improvementScore?: number,
  calculationTime?: number
) => {
  try {
    const res = await API_V1.post(
      '/user-tracking/trackers/external',
      {
        profile,
        username,
        timeOfStart,
        timeOfEnd,
        imitationScore,
        detailsCategoryScoreStart,
        detailsCategoryScoreEnd,
        improvementScore,
        calculationTime,
      },
      {
        headers: {
          'x-api-key': apiKey,
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        },
      }
    );
    return res.data;
  } catch (e) {
    Logger.trace('Error while creating user tracker');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};
